import { TextInput } from '@mantine/core';
import { Search } from 'lucide-react';
import { FC } from 'react';

interface Props {
    onChange: (value: string) => void;
    value: string;
    placeholder?: string;
}

const TextFilter: FC<Props> = ({ placeholder = 'Search', onChange, value = '' }) => {
    return (
        <TextInput
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.currentTarget.value)}
            rightSectionPointerEvents="none"
            rightSection={<Search className="size-6" />}
            className="flex-grow"
        />
    );
};

export default TextFilter;
